import {
    ICarrierStoreEventHandler,
    ParcelConfirmedParameters,
    ParcelScannedParameters,
    ParcelScannedResult,
    ParcelStoreCancelledParameters
} from './ICarrierStoreEventHandler';
import { UpsCarrierStoreEventHandler } from './UpsCarrierStoreEventHandler';
import {DhlCarrierStoreEventHandler} from "./DhlCarrierStoreEventHandler";

export class CarrierStoreEventHandler implements ICarrierStoreEventHandler {
    async parcelScanned(params: ParcelScannedParameters): Promise<ParcelScannedResult | undefined> {
        switch (params.carrierId) {
            case "dhl":
                return await new DhlCarrierStoreEventHandler().parcelScanned(params);
            default:
                return undefined;
        }
    }

    async parcelStoreCancelled(params: ParcelStoreCancelledParameters): Promise<void> {
        switch (params.carrierId) {
            default:
                return;
        }
    }

    async parcelStoreConfirmed(params: ParcelConfirmedParameters): Promise<void> {
        switch (params.carrierId) {
            case "ups":
                await new UpsCarrierStoreEventHandler().parcelStoreConfirmed(params);
        }
    }


}